/**
 * SpecInput component for Solar Design panel specs
 * Extracted from SolarDesignPage.js for maintainability
 */
import React from "react";

export function SpecInput({ label, field, unit, min, max, step = 0.01, spec, onSpecChange }) {
  const [localVal, setLocalVal] = React.useState(String(spec[field]));
  const prevSpec = React.useRef(spec[field]);

  React.useEffect(() => {
    if (spec[field] !== prevSpec.current) {
      setLocalVal(String(spec[field]));
      prevSpec.current = spec[field];
    }
  }, [spec, field]);

  return (
    <div>
      <label style={{ display: "block", fontSize: "10px", fontWeight: "700", letterSpacing: "0.07em", textTransform: "uppercase", color: "#8AA496", marginBottom: "4px" }}>
        {label}
      </label>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <input
          type="number" min={min} max={max} step={step}
          value={localVal}
          onChange={e => {
            setLocalVal(e.target.value);
            const v = parseFloat(e.target.value);
            if (!isNaN(v)) {
              prevSpec.current = v;
              onSpecChange(field, v);
            }
          }}
          style={{ flex: 1, background: "#F5F8F5", border: "1px solid rgba(46,100,68,0.15)", borderRadius: "7px", padding: "7px 8px", fontSize: "13px", color: "#1B2B22", outline: "none", fontFamily: "Manrope, sans-serif" }}
          onFocus={e => { e.target.style.borderColor = "rgba(47,125,82,0.5)"; e.target.style.boxShadow = "0 0 0 3px rgba(47,125,82,0.08)"; }}
          onBlur={e => {
            e.target.style.borderColor = "rgba(46,100,68,0.15)";
            e.target.style.boxShadow = "none";
            if (e.target.value === "" || isNaN(parseFloat(e.target.value))) {
              setLocalVal(String(spec[field]));
            }
          }}
          data-testid={`spec-${field}`}
        />
        {unit && <span style={{ fontSize: "11px", color: "#8AA496", whiteSpace: "nowrap" }}>{unit}</span>}
      </div>
    </div>
  );
}
